module.exports = __webpack_public_path__ + "img/MoonSword 5b.8793b7ab.png";